import { gql } from '@apollo/client';

export const FETCH_PLAN_TEMPLATE = gql`
  query Flex_FetchPlanTemplate($id: Int!) {
    planTemplate(id: $id) {
      id
      enrollmentDataSourceName
      billingExperienceType
      products {
        id
        productType
      }
    }
  }
`;
